module.exports = __webpack_public_path__ + "static/img/3.579cc4ff.png";